import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const APIDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="container">
      <div className="card p-2 d-flex" style={{ height: "60vh", justifyContent: "center", alignItems: "center" }}>
        <h5 className="text-primary">Redirecting you to the API documentation...</h5>
      </div>
    </div>
  );
}

export default APIDoc;
